import React from 'react';
import './Codebreaker.css';
import RiddleCard from "../RiddleCard/RiddleCard";

const Codebreaker = ({ status }) => {
    const connected = status !== null;
    const { rfid, charge_level, solved } = status ?? {};
    const ledsCount = 12;
    const activeLeds = Math.min(charge_level ?? 0, ledsCount);

    const leds = [];
    for (let i = 0; i < ledsCount; i++) {
        leds.push(
            <div 
                key={i} 
                className={`led ${i < activeLeds ? 'active' : 'inactive'}`}
            ></div>
        );
    }

    const mainDiv = (
        <div className="codebreaker-container">
            <div className="status-info">
                <div className={`rfid-status ${rfid ? 'detected' : 'waiting'}`}>
                    <label>RFID:</label> <span>{rfid ? 'Recognized' : 'Waiting...'}</span>
                </div>
                <div className="charge-info">
                    <label>Charge:</label> <span>{Math.round(((charge_level ?? 0) / ledsCount) * 100)}%</span>
                </div>
            </div>
            
            <div className="leds-grid">
                {leds}
            </div>
        </div>
    );

    return (
        <RiddleCard
            title={"Codebreaker"}
            allSolved={solved}
            mainInfo={mainDiv}
            connected={connected}
            index={0}
            layout="half-size"
        />
    );
};

export default Codebreaker;
